/* eslint-disable i18next/no-literal-string --
 * React Query cache keys.
 */
/**
 * `entities/taxonomy-dataset` TanStack Query key factory.
 *
 * Surface:
 *   - `TAXONOMY_DATASET_QUERY_KEYS.all`          → `['taxonomy-datasets']`
 *   - `….list()`                                → `['taxonomy-datasets', 'list']`
 *   - `….detail(id)`                            → `['taxonomy-datasets', 'detail', id]`
 *   - `….records(id)`                           → `['taxonomy-datasets', 'detail', id, 'records']`
 *
 * `records` nests UNDER `detail` so invalidating a dataset cascades to its grid —
 * a rename does not, but a duplicate or a bulk delete does, and the alternative
 * is remembering to invalidate two keys at every call site.
 */
export const TAXONOMY_DATASET_QUERY_KEYS = {
  all: ['taxonomy-datasets'] as const,

  list: () => [...TAXONOMY_DATASET_QUERY_KEYS.all, 'list'] as const,

  detail: (id: string) => [...TAXONOMY_DATASET_QUERY_KEYS.all, 'detail', id] as const,

  records: (id: string) => [...TAXONOMY_DATASET_QUERY_KEYS.detail(id), 'records'] as const,
} as const;
